/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_SubtitleInputs */

const en_fc_home_hero_subtitle = /** @type {(inputs: Fc_Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free and open source from ArtCraft. Install it on Mac, Windows or Linux, run it in your browser, and see how it compares with Adobe Premiere Pro.`)
};

/**
* | output |
* | --- |
* | "Free and open source from ArtCraft. Install it on Mac, Windows or Linux, run it in your browser, and see how it compares with Adobe Premiere Pro." |
*
* @param {Fc_Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_subtitle = /** @type {((inputs?: Fc_Home_Hero_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_subtitle(inputs)
});
export { fc_home_hero_subtitle as "fc.home.hero.subtitle" }